import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col font-sans" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "truncate text-xl" }, "StreetsPDX", -1)
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex-grow" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_DropdownList = _resolveComponent("DropdownList")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      open: _ctx.menuOpen,
      onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
    }, {
      branding: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: "/",
          class: "w-full flex items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Logo, { class: "w-16 md:w-20 mr-3 flex-shrink-0" }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      menu: _withCtx(() => [
        _createVNode(_component_Nav, {
          class: "md:ml-auto",
          "list-class": "flex flex-col gap-2 md:gap-3 md:flex-row md:items-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("li", null, [
              _createVNode(_component_Dropdown, {
                label: "Street types",
                id: "street-types"
              }, {
                label: _withCtx(({ label, open }) => [
                  _createVNode(_component_router_link, {
                    to: "/street-types",
                    custom: ""
                  }, {
                    default: _withCtx(({ href, navigate }) => [
                      _createVNode(_component_Anchor, {
                        url: href,
                        onClick: _withModifiers(navigate, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(label), 1)
                        ]),
                        _: 2
                      }, 1032, ["url", "onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_Icon, {
                    "aria-label": "Open dropdown",
                    type: "solid",
                    name: open ? 'chevron-up' : 'chevron-down',
                    class: "ml-2 w-5 h-5"
                  }, null, 8, ["name"])
                ]),
                default: _withCtx(({ open, toggle }) => [
                  _createVNode(_component_DropdownList, {
                    as: "ul",
                    id: "street-types",
                    open: open,
                    class: "md:absolute md:bg-white p-3 md:mt-[2.5rem] md:min-w-max"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                      ['civic-main-street', 'Civic Main Streets'],
                      ['civic-corridor', 'Civic Corridors'],
                      ['neighborhood-main-street', 'Neighborhood Main Streets'],
                      ['neighborhood-corridor', 'Neighborhood Corridors'],
                      ['community-corridor', 'Community Corridors'],
                      ['local-street', 'Local Streets'],
                      ['industrial-road', 'Industrial Roads'],
                    ], (x) => {
                        return _createVNode(_component_NavItem, {
                          key: x,
                          text: x[1],
                          to: `/street-types/${x[0]}`,
                          onClick: toggle
                        }, null, 8, ["text", "to", "onClick"])
                      }), 64))
                    ]),
                    _: 2
                  }, 1032, ["open"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_NavItem, {
              text: "City Projects",
              to: "/city-projects"
            }),
            _createVNode(_component_NavItem, {
              text: "Development Improvements",
              to: "/development-improvements"
            }),
            _createVNode(_component_NavItem, {
              text: "Right-of-way Policies",
              to: "//portland.gov/transportation/permitting/city-standards-guidelines-requirements-impact-space-right-way"
            }),
            _createElementVNode("li", null, [
              _createVNode(_component_Dropdown, {
                label: "Tools",
                id: "tools"
              }, {
                label: _withCtx(({ label, open }) => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(label), 1),
                  _createVNode(_component_Icon, {
                    "aria-label": "Open dropdown",
                    type: "solid",
                    name: open ? 'chevron-up' : 'chevron-down',
                    class: "ml-2 w-5 h-5"
                  }, null, 8, ["name"])
                ]),
                default: _withCtx(({ open }) => [
                  _createVNode(_component_DropdownList, {
                    as: "ul",
                    id: "tools",
                    open: open,
                    class: "md:absolute md:bg-white p-3 md:mt-[2.5rem] md:-ml-[10.5rem] md:min-w-max"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NavItem, {
                        text: "Street Map",
                        to: "/streets"
                      }),
                      _createVNode(_component_NavItem, {
                        text: "Cross-Sections Viewer",
                        to: "/cross-section"
                      }),
                      _createVNode(_component_NavItem, {
                        text: "Sidewalk Tradeoffs Evaluation",
                        to: "/sidewalk-tradeoffs"
                      })
                    ]),
                    _: 2
                  }, 1032, ["open"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("main", _hoisted_4, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_Footer, {
      color: "gray",
      variant: "light"
    }, {
      middle: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Nav, { title: "General information" }, {
            default: _withCtx(() => [
              _createVNode(_component_NavItem, { to: "https://portland.gov" }, {
                default: _withCtx(() => [
                  _createTextVNode("City of Portland")
                ]),
                _: 1
              }),
              _createVNode(_component_NavItem, { to: "https://portland.gov/transportation" }, {
                default: _withCtx(() => [
                  _createTextVNode("Portland Bureau of Transportation")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Nav, { title: "Legal notices" }, {
            default: _withCtx(() => [
              _createVNode(_component_NavItem, { to: "/disclaimer" }, {
                default: _withCtx(() => [
                  _createTextVNode("Disclaimer")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Nav, { title: "Help" }, {
            default: _withCtx(() => [
              _createVNode(_component_NavItem, { to: "/training" }, {
                default: _withCtx(() => [
                  _createTextVNode("Training videos")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}